import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './rejectReasonShipmentModalComponent.css';
// import orderUpdatedSuccessfullyModal from '../../src/assets/images/orderUpdatedSuccessfullyModal.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState, Fragment } from 'react';
import rejectModalBaseImage from '../../../src/assets/images/Reject_modal_base_image.png';
import rejectIcon from '../../../src/assets/images/Rejected_icon.png';
import rejectIconImage from '../../../src/assets/images/Reject_icon_image.png';
import questionMarkIcon from '../../../src/assets/images/question-mark.svg'


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

export default function RejectReasonShipmentModalComponent({rejectReasonData}) {
  console.log("rejectReasonData",rejectReasonData);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment >
      <button className="icon-clay delete" onClick={handleClickOpen}>
                    <span class="inner-clay color-red"> <img src={questionMarkIcon} alt="Reason" /></span>
                </button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md" // Adjust the maxWidth as needed
        maxHeight="md" // Adjust the maxHeight as needed
        
      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
              <div className='shipmentRejectedSuccessfullyModalImagediv'>  
                    <div>
                        <img 
                            className='shipmentRejectedSuccessfullyModalImage'
                            src={rejectModalBaseImage}
                        /> 
                        <img style={{marginTop:"-175px", marginLeft:"60px"}}
                                src={rejectIconImage}
                        />
                    </div>
               
              </div> 
                <div>
                    <img style={{marginLeft:"43%", marginTop:"6%"}}
                     src={rejectIcon}
                    />
                    <h4 style={{marginLeft:"30%", fontSize:"smaller", marginTop:"2%"}}>
                       { rejectReasonData.rejectedDate }
                    </h4>
                    <h5 className='headingForShipmentRejectedSuccessfullyModal'
                    >  { rejectReasonData.rejectedReason } </h5>
                </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor:"white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </Fragment>
  );
}
